export const setPaymentOptions = (state, payload) => {
    state.paymentOptions = payload;
};